// src/pages/PameBrosta.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './PameBrosta.css';

const PameBrosta = () => {
  return (
    <div className="pame-brosta-page">
      <div className="pame-brosta-container">
        
        {/* Logo Section */}
        <div className="logo-section">
          <img 
            src="/assets/pame-logo.jpg" 
            alt="PAME BROSTA Logo" 
            className="main-logo"
          />
        </div>

        {/* Content Block 1 */}
        <div className="content-block">
          <img 
            src="/assets/Pame/1.jpg" 
            alt="Greek Village" 
            className="block-image"
          />
          <div className="block-text">
            <p>
              Operation Pame Brosta exists to repopulate Greece's villages, restore opportunity for future generations, and reconnect Greeks worldwide to a shared mission of renewal through incentives, awareness, education, entrepreneurship, and coordinated action.
            </p>
            <p>
              For generations Greeks migrated in search of financial stability and a better life, not because Greece lacked talent - it lacked opportunities. Wherever Greeks established communities, they distinguished themselves as builders of cities and institutions, advancing education, economic growth, and prosperity, while making significant contributions across a wide range of industries.
            </p>
          </div>
        </div>

        {/* Content Block 2 */}
        <div className="content-block">
          <p className="highlight-red">THEIR DNA NEVER CHANGED ONLY THE ENVIRONMENT DID.</p>
          <img 
            src="/assets/Pame/2.jpg" 
            alt="Empty Greek Village" 
            className="block-image"
          />
          <div className="block-text">
            <p>
              Today the Greek villages are empty. The new generation of Greeks have left to survive, not to dream. Families became fragmented across continents, and many children and grandchildren of the diaspora no longer choose to visit, as towns have lost their youth, vitality, and essential conveniences.
            </p>
          </div>
        </div>

        {/* Content Block 3 */}
        <div className="content-block">
          <p className="highlight-red">PAME BROSTA IS ABOUT REALIZING PURPOSE.</p>
          <img 
            src="/assets/Pame/3.jpg" 
            alt="Greek Culture" 
            className="block-image"
          />
          <div className="block-text">
            <p>
              The light of love and wisdom never disappeared. What is required now is to carry forward what came before, and keep the identity, culture, language, and community alive.
            </p>
            <p>
              The strongest incentive is not money - it is the future of our children and grandchildren, asking the diaspora to return and rebuild. Bringing their children and grandchildren back to Greece to spend more time, and flourish alongside the Greeks who are there now.
            </p>
            <p>
              The villages can become a launch pad to reconnect with their roots - not a dead end. And government incentives should be utilized.
            </p>
          </div>
        </div>

        {/* Content Block 4 */}
        <div className="content-block">
          <img 
            src="/assets/Pame/4.jpg" 
            alt="Ancient Greek Heritage" 
            className="block-image"
          />
          <div className="block-text">
            <p>
              Young Greeks and diaspora youth must be reminded: you come from the civilization that founded:
            </p>
            <div className="list-red">
              <p>• SCIENCE • TECHNOLOGY • ENGINEERING • ARTS • MATHEMATICS • PHILOSOPHY • PHILANTHROPY • DEMOCRACY AND THE OLYMPIC GAMES</p>
            </div>
            <p>
              These were the foundations of Western civilization as we know it. This is not mythology - these are historical facts.
            </p>
          </div>
        </div>

        {/* Content Block 5 */}
        <div className="content-block">
          <img 
            src="/assets/Pame/5.jpg" 
            alt="Greek Diaspora" 
            className="block-image"
          />
          <div className="block-text">
            <p>
              PAME BROSTA is a call to the Omogenia - Greeks who migrated from Greece, and those born to immigrants - to recognize their shared role in what comes next.
            </p>
            <p>
              Greeks abroad helped build their new countries. They built cities and skylines, advanced education and science, strengthened economies, supported institutions, and contributed across industry, culture, and technology.
            </p>
            <p>
              We will never forget our new countries, and we will never turn our backs on them.
            </p>
            <p className="highlight-red">But we have given enough.</p>
            <p className="highlight-red">Now it is time to rebuild Greece - together.</p>
          </div>
        </div>

        {/* Content Block 6 */}
        <div className="content-block">
          <img 
            src="/assets/Pame/6.jpg" 
            alt="Theometrics Olympics" 
            className="block-image"
          />
          <div className="block-text">
            <p>
              Through the Theometrics Olympics and the example of the{' '}
              <Link to="/olympic-angels" className="underlined-link">
                Olympic Angels by Theo
              </Link>
              , PAME BROSTA advances purpose, character, excellence, and contribution as living standards.
            </p>
            <p>
              This work is supported by the International Olympic Academy (IOA), experiential learning, PhD-level programs at Theometrics University, and entrepreneurial teaching and training delivered through Angel Houses across Greece, the United States, Italy, and Ukraine.
            </p>
          </div>
        </div>

        {/* Content Block 7 */}
        <div className="content-block">
          <img 
            src="/assets/Pame/7.jpg" 
            alt="Anagenisi Case Studies" 
            className="block-image"
          />
          <div className="block-text">
            <p>
              Together with real Anagenisi case studies - Analipsi, Nafpaktos, and Trizonia - these initiatives show how renewal begins locally and grows through participation.
            </p>
            <p>
              This is an open invitation to those who recognize what is at stake and choose to participate.
            </p>
          </div>
        </div>

        {/* Final Block */}
        <div className="content-block final-block">
          <img 
            src="/assets/Pame/8.jpg" 
            alt="PAME BROSTA Movement" 
            className="block-image"
          />
          <div className="block-text">
            <p className="highlight-red">PAME BROSTA - FORWARD TOGETHER…</p>
            <p className="highlight-red">CATCH US IF YOU CAN.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default PameBrosta;
